var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgEquaLogo16X16 = function SvgEquaLogo16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.03c-4.144 0-7.5-3.363-7.5-7.515C0 3.362 3.356 0 7.5 0S15 3.362 15 7.515c0 4.152-3.356 7.514-7.5 7.514zm0-13.807c-3.458 0-6.28 2.827-6.28 6.292 0 3.464 2.822 6.291 6.28 6.291a6.283 6.283 0 006.28-6.291A6.283 6.283 0 007.5 1.223z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.288 4.127c0 .764-.636 1.4-1.399 1.4H6.23c-.662 0-1.22.536-1.22 1.223 0 .051-.052.102-.103.102-.05 0-.101-.05-.101-.102V5.451c0-.764.635-1.4 1.398-1.4h4.958c.076-.026.127.025.127.076z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.144 6.495H6.23c-.763 0-1.398.637-1.398 1.401v1.3c0 .05.05.101.101.101.051 0 .102-.05.102-.101 0-.663.534-1.223 1.22-1.223h2.619c.763 0 1.398-.637 1.398-1.401a.14.14 0 00-.127-.077z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.102 8.941H6.229c-.763 0-1.398.637-1.398 1.401v1.3c0 .05.05.101.076.101.05 0 .102-.05.102-.102 0-.662.533-1.223 1.22-1.223h1.576c.763 0 1.398-.636 1.398-1.4 0-.026-.05-.077-.101-.077z",
    fill: "#fff"
  })));
};

export default SvgEquaLogo16X16;